import React from "react";
import { withStyles } from "@material-ui/core";
import update from "immutability-helper";
import { get, map, isEmpty, sortBy } from "lodash";

import Grid from "@material-ui/core/Grid";

import colors from "../../../assets/style/colors";
import images from "../../../assets/img/images";
import OnsiteCountDialog from "./OnsiteCountDialog";

const styles = {
  container: {
    marginBottom: "24px",
    backgroundColor: colors.lightGrey,
    borderRadius: "4px",
    padding: "14px",
    paddingBottom: 0,
    display: "inline-block",
  },
  title: {
    textTransform: "uppercase",
    color: colors.black87,
    fontWeight: 500,
  },
  profileSection: {
    minWidth: "170px",
    padding: "12px",
    display: "flex",
    alignItems: "center",
    "& img": {
      height: "30px",
      marginRight: "16px",
    },
  },
  value: {
    fontSize: "1.857em",
    color: colors.primary,
    fontWeight: 500,
    cursor: "pointer",
    "&:hover": {
      textDecoration: "underline",
    },
  },
};

const ProfilesBox = (props) => {
  const { classes, title, data } = props;
  const [open, setOpen] = React.useState(false);
  const [filters, setFilters] = React.useState(props.filters);

  React.useEffect(() => {
    setFilters(props.filters);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [JSON.stringify(props.filters)]);

  if (isEmpty(data)) {
    return null;
  }

  return (
    <Grid
      container
      direction="column"
      className={classes.container}
      wrap="nowrap"
    >
      <OnsiteCountDialog open={open} setOpen={setOpen} filters={filters} />
      <Grid item className={classes.title}>
        {title}
      </Grid>
      <Grid item container wrap="nowrap">
        {map(
          sortBy(get(data, ["profile_types"]), (t) => t.id),
          (type) => (
            <Grid
              item
              container
              xs={3}
              key={get(type, ["id"])}
              className={classes.profileSection}
            >
              <Grid item className="flexCenter">
                <img
                  src={
                    get(type, ["id"]) === 1
                      ? images.humanIconBlack
                      : get(type, ["id"]) === 2
                      ? images.truckIconBlack
                      : get(type, ["id"]) === 3
                      ? images.trailerIconBlack
                      : get(type, ["id"]) === 4
                      ? images.containerIconBlack
                      : null
                  }
                  alt="human"
                />
              </Grid>
              <Grid
                item
                className={classes.value}
                onClick={() => {
                  setOpen(true);
                  setFilters(
                    update(filters, {
                      profile_type_ids: { $set: [get(type, ["id"])] },
                    })
                  );
                }}
              >
                {get(type, ["profile_count"]) || 0}
              </Grid>
            </Grid>
          )
        )}
      </Grid>
    </Grid>
  );
};

export default withStyles(styles)(ProfilesBox);
